/*!
 *
 *  related-slider.ts
 *
 */
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
export default function (elem) {
    const heroSliderWrapper = elem.querySelector('.top-hero-slider__wrapper');
    const herSliderItems = heroSliderWrapper.querySelectorAll('.top-hero-card');
    const heroPlay = document.querySelector('#topHeroPlay');
    herSliderItems.forEach((item) => {
        const clone = item.cloneNode(true);
        heroSliderWrapper.appendChild(clone);
    });
    const swiper = new Swiper(elem, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 80,
        speed: 700,
        loop: true,
        centeredSlides: true,
        breakpoints: {
            0: {
                spaceBetween: 16,
                centeredSlides: false,
            },
            768: {
                spaceBetween: 40,
                centeredSlides: true,
            },
            1280: {
                spaceBetween: 80,
                centeredSlides: true,
            }
        },
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: '#topHeroNext',
            prevEl: '#topHeroPrev',
        },
        pagination: {
            el: '#topHeroFraction',
            type: "custom",
            renderCustom: function (swiper, current, total) {
                swiper;
                let _current = current % (total / 2) === 0 ? total / 2 : current % (total / 2);
                return `<span class="top-hero__fraction__item">${_current}</span> / <span class="top-hero__fraction__item">${total / 2}</span>`;
            }
        }
    });
    heroPlay.addEventListener('click', (e) => {
        e.preventDefault();
        if (swiper.autoplay.running) {
            swiper.autoplay.stop();
            heroPlay.setAttribute('aria-label', '再生する');
            heroPlay.classList.add('-pause');
        }
        else {
            swiper.autoplay.start();
            heroPlay.setAttribute('aria-label', '一時停止');
            heroPlay.classList.remove('-pause');
        }
    });
}
